import { object } from 'yup';
import { dadosBancariosSchema } from './dados-bancarios';
import { dadosContatoSchema } from './dados-contato';
import { dadosPessoaisSchema } from './dados-pessoais';
import { enderecoSchema } from './endereco';

export const DadosUsuarioSchema = object().shape({
  ...dadosBancariosSchema.fields,
  ...dadosContatoSchema.fields,
  ...dadosPessoaisSchema.fields,
  ...enderecoSchema.fields,
});
